"use client";

import { supabase } from "@/lib/supabase";
import type { NearMeFunnelMetricAction } from "@/lib/push-notifications/near-me-notification-metrics";

/**
 * Record a near-me funnel/settings event (authenticated). No PII stored server-side.
 */
export async function recordNearMeFunnelMetric(
  action: NearMeFunnelMetricAction,
  metadata?: Record<string, unknown>,
): Promise<void> {
  try {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    if (!session?.access_token) return;

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 2000);

    const response = await fetch("/api/metrics/near-me/events", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${session.access_token}`,
      },
      body: JSON.stringify({ action, metadata: metadata ?? null }),
      signal: controller.signal,
    });
    clearTimeout(timeoutId);

    if (!response.ok) {
      console.warn("Near-me metrics API returned:", response.status);
    }
  } catch (err) {
    const e = err as { name?: string } | null;
    if (e?.name !== "AbortError") {
      console.warn("Near-me funnel metric failed:", err);
    }
  }
}
